import { IsString, Matches } from 'class-validator';

export class CodeVerificationDto {
  @IsString()
  @Matches(/^\d{6}[A-Z]{2}$/, {
    message: 'The code must contain 6 digits followed by 2 uppercase letters (e.g., 123456AB)',
  })
  code!: string;
}
